import axios from 'axios'
import { domains } from './config'

const baseApiAddress = `${domains.SS_API}`

export const createClient = customAddress => {
  const _api = axios.create({
    baseURL: customAddress || baseApiAddress,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })

  let authInstance

  _api.interceptors.request.use(async request => {
    const token = await authInstance.getAccessTokenSilently()
    request.headers.Authorization = `Bearer ${token}`
    return request
  })

  _api.interceptors.response.use(
    response => {
      return response
    },

    error => {
      if (error.response.status === 401) {
        location.replace(window.location.origin)
      }
      return Promise.reject(error)
    },
  )

  return {
    setAuthInstance: async newAuthInstance => {
      authInstance = newAuthInstance
    },
    delete: _api.delete,
    get: _api.get,
    patch: _api.patch,
    post: _api.post,
    put: _api.put,
  }
}

export default createClient()



// WEBPACK FOOTER //
// ./src/lib/Api.js